import { Loader2 } from 'lucide-react';
import type { ConnectionStatus } from '@/hooks/use-session-socket';

interface ConnectionBannerProps {
  status: ConnectionStatus;
}

/**
 * Banniere fine en haut de page qui s'affiche quand la connexion Socket.IO
 * est coupee ou en cours de re-etablissement. Cas typique mobile : passage
 * wifi/4G, mise en veille de l'ecran, application en background trop longtemps.
 *
 * - aria-live="polite" : annonce les changements de connexion aux SR sans interrompre.
 * - role="status" : indique qu'il s'agit d'une zone d'etat dynamique.
 * - Affiche rien quand status === 'connected' (pas de bruit visuel inutile).
 */
export function ConnectionBanner({ status }: ConnectionBannerProps) {
  if (status === 'connected') return null;

  const label = status === 'reconnecting' ? 'Reconnexion en cours...' : 'Connexion perdue';

  return (
    <div
      role="status"
      aria-live="polite"
      className="mb-4 flex items-center justify-center gap-2 rounded-md border border-primary/40 bg-primary/10 px-3 py-2 text-xs text-primary"
    >
      <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
